
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import api from "@/api";
import { TenantSettingsEditDto, AliyunOssSettingsEditDto } from "../../../api/appService";

@Component
export default class Calc extends Vue {
  form: AliyunOssSettingsEditDto = {
    bucketName:undefined,
    endPoint:undefined,
    accessId:undefined,
    accessKey:undefined,
    fileUrl:undefined,
    imageUrl:undefined,
  };

  created() {
    this.fetchData();
  }

  async fetchData() {
    await api.tenantSetting.getAliyunOssSettings().then(res => {
      this.form = res;
    });
  }

  async onSubmit() {
    await api.tenantSetting
      .updateAliyunOssSettings({
        body: this.form
      })
      .then(res => {
        this.$message.success("更新成功!");
      });
    await this.fetchData();
  }
  onCancel() {
    this.$message({
      message: "cancel!",
      type: "warning"
    });
  }
}
